import { closePromotionToast } from 'dux/user/actions';

import { actions } from './slice';

export const { onUpsellSubscriptionClick, resetShipNowOrderState } = actions;
export * from './thunks';

export const closeShipNowErrorToast = () => dispatch => {
  dispatch(resetShipNowOrderState());
  dispatch(closePromotionToast());
};
